export var IFRAME_SCROLL_ELEMENT_ID = 'iframe-scroll-element';
// Component Names, e.g. for tracking or publishing
export var CLOSABLE_CONTAINER = 'ClosableContainer';
// Component Actions
export var CLOSED = 'closed';
export var DEFAULT_DISTANCE_UNIT = 'km';
